import { InputFieldSet } from "PFComponents/text/input_field_set";
import useForceUpdate from "PFCore/helpers/use_force_update";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import css from "../overwrites.module.scss";
import ResetButton from "../reset_button";
import Skills from "./skills";

const CustomField = ({ exportableProfile, name, displayAs, onModified, timesModified }) => {
  const forceUpdate = useForceUpdate();

  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    if (timesModified === 0) {
      setHasChanged(false);
    }
  }, [timesModified]);

  useEffect(() => {
    onModified((prev) => prev + 1);
  }, [hasChanged]);

  useEffect(() => {
    setHasChanged(exportableProfile.hasChangedCustomFieldValue(name));
  }, [exportableProfile.hasChangedCustomFieldValue(name)]);

  if (name === "skills") {
    const skills = exportableProfile.getCategorisedSkills();
    return <Skills skills={skills} exportableProfile={exportableProfile} cfName={name} />;
  }

  return (
    <tr className={css.customField}>
      <td style={{ width: "100%" }}>
        <InputFieldSet
          label={displayAs}
          onChange={(val) => {
            exportableProfile.updateCustomFieldValue(name, val.replaceAll("</>", "\r"));
            setHasChanged(val);
          }}
          value={exportableProfile.getCustomFieldValue(name).replaceAll("\r", "</>") || ""}
        />
      </td>
      <td className={css.resetLabel}>
        {hasChanged && timesModified > 0 && (
          <ResetButton
            onClick={() => {
              exportableProfile.resetCustomFieldValue(name);
              setHasChanged(false);
              onModified((prev) => prev - 1);
              forceUpdate();
            }}
          />
        )}
      </td>
    </tr>
  );
};

CustomField.propTypes = {
  exportableProfile: PropTypes.object.isRequired,
  name: PropTypes.string,
  displayAs: PropTypes.string,
  onModified: PropTypes.func,
  timesModified: PropTypes.number
};

export default CustomField;
